export default __webpack_public_path__ + "static/media/tete32.1ce1e175.png";